import * as actionTypes from './actionTypes';

const initialState = {
  idsBySpaceId: {},
  folders: {},
  isLoading: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.spaceId || 'all']: true,
        },
      };

    case actionTypes.FETCH_SUCCESS:
      return {
        ...state,
        idsBySpaceId: {
          ...state.idsBySpaceId,
          [action.spaceId || 'all']: action.ids,
        },
        isLoading: {
          ...state.isLoading,
          [action.spaceId || 'all']: false,
        },

      };

    default:
      return state;
  }
};
